var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPlayerPlay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.007.328l8.096 5.452c1.196.805 1.196 2.635 0 3.44l-8.096 5.452C1.708 15.547 0 14.57 0 12.952V2.048C0 .43 1.708-.547 3.007.328"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPlayerPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico-player-play.f0c427e130f1918d370e9d108ab84198.svg";